import { useState } from 'react';
import { BsDownload } from 'react-icons/bs';
import { useSelector } from 'react-redux';

import { charCodeType } from '../../../../../common/CharCode.type';
import { selectAllContacts, selectContactFilterType } from '../../../../../slices/contactAddressSlice';

import { preprocessExportData } from '../../../../../util/exportFormatProcessor';
import { createDownloadFileUrl } from '../../../../../util/createDownloadFileUrl';

import SelectCharCode from './SelectCharCode';
import SelectFormat from './SelectFormat';
import { BulkDeleteButton } from './BulkDeleteButton';

const ExportContact = () => {
  const [charCode, setCharCode] = useState<charCodeType>('utf8');
  const [format, setFormat] = useState<string>("standard");
  const [isEncodingLocked, setIsEncodingLocked] = useState(false);
  const [resetSignal, setResetSignal] = useState(0);

  const allContactAddresses = useSelector(selectAllContacts);
  const contactFilterType = useSelector(selectContactFilterType);

  const createCSV = (e: any) => {

    const filtered = allContactAddresses
      .filter(
        (item) =>
          contactFilterType === "all" || item.category === contactFilterType
      )
      .map((contact) => ({
        ...contact,
        profileImage: "",
      }));

    const formatted = preprocessExportData(filtered, format);

    const { url, fileName } = createDownloadFileUrl(
      formatted,
      charCode,
      format,
    );

    e.currentTarget.href = url;
    e.currentTarget.download = fileName;

    setTimeout(() => {
      setCharCode("utf8");
      setFormat("standard");
      setIsEncodingLocked(false);
      setResetSignal(prev => prev + 1);

    }, 0);
  };

  return (
    <div className="m-4 mt-5 d-flex justify-content-between align-items-center">
      <div>
        <span className="ms-1">
          <a  href="about:blank" download onClick={(e) => createCSV(e)}>
            <BsDownload size={'1rem'} />
            連絡先をエクスポート
          </a>
          （CSV形式、インポート先に応じて文字コードと書式を選択してください）
        </span>

        <div className="d-flex align-items-center gap-2 mt-2">
          <SelectFormat
            format={format}
            setFormat={setFormat}
            setCharCode={setCharCode}
            setIsEncodingLocked={setIsEncodingLocked}
            resetSignal={resetSignal}
          />
          
          <SelectCharCode
            charCode={charCode}
            setCharCode={setCharCode}
            disabled={isEncodingLocked}
            kind="export"
            resetSignal={resetSignal}
          />
        </div>
      </div>
      <BulkDeleteButton />
    </div>
  );
};

export default ExportContact;
